import React from 'react'
import { IndexLink, Link } from 'react-router'
import PropTypes from 'prop-types'
import '../PageLayout/PageLayout.scss'

export const CallbackLayout = ({ children }) => (
  <div>
    <nav className="navbar navbar-toggleable-md bg-inverse navbar-inverse bg-faded">
    <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <a className="navbar-brand" href="#">Le Utthe</a>
    <div className="collapse navbar-collapse pull-right" id="navbarNavDropdown">
    </div>
  </nav>
  <div className='container text-center'>
    <div className='page-layout__viewport'>
      {children}
    </div>
  </div>
</div>
)

CallbackLayout.propTypes = {
  children: PropTypes.node
}



// WEBPACK FOOTER //
// ./src/layouts/CallbackLayout/CallbackLayout.js